var _g, _g2, _g3, _g4, _path, _path2, _path3, _path4, _path5, _g5, _path6, _path7, _g6, _path8, _path9, _g7, _ellipse, _g8, _ellipse2, _path10, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path11, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPath(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 471,
    viewBox: "0 0 220 471",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_4149_13)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.8034,
    cy: 200.551,
    rx: 49.0846,
    ry: 21.509,
    fill: "#F19B38"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_4149_13)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 133.706,
    cy: 361.592,
    rx: 49.0846,
    ry: 21.509,
    fill: "#3E91E1",
    fillOpacity: 0.4,
    shapeRendering: "crispEdges"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_4149_13)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 117.163,
    cy: 442.113,
    rx: 49.0846,
    ry: 21.509,
    fill: "#3E91E1",
    fillOpacity: 0.4,
    shapeRendering: "crispEdges"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_dd_4149_13)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.0846,
    cy: 21.509,
    rx: 49.0846,
    ry: 21.509,
    transform: "matrix(-1 0 0 1 136.465 259.562)",
    fill: "#58A1FC"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150.805 117.824C162.386 111.022 184.998 93.0058 182.792 75.3574",
    stroke: "#79D37B",
    strokeOpacity: 0.42,
    strokeWidth: 6.61815,
    strokeLinecap: "round",
    strokeDasharray: "11.03 11.03"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5284 140.078C8.88148 142.285 3.64483 155.032 11.6147 170.932",
    stroke: "#A3D9C8",
    strokeWidth: 6.61815,
    strokeLinecap: "round",
    strokeDasharray: "11.03 11.03"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M146.942 267.835C155.336 252.156 141.27 217.921 123.687 215.241",
    stroke: "#6BA6EA",
    strokeWidth: 6.61815,
    strokeLinecap: "round",
    strokeDasharray: "11.03 11.03"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.106 323.538C52.8643 337.327 52.8643 338.43 68.0269 345.668",
    stroke: "#6BA6EA",
    strokeWidth: 6.61815,
    strokeLinecap: "round",
    strokeDasharray: "11.03 11.03"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M188.35 440.632C205.998 435.668 212.616 404.232 197.174 386.584",
    stroke: "#6BA6EA",
    strokeOpacity: 0.6,
    strokeWidth: 6.61815,
    strokeLinecap: "round",
    strokeDasharray: "11.03 11.03"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_dd_4149_13)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.3815,
    cy: 120.03,
    rx: 49.0846,
    ry: 21.509,
    fill: "#79D37B"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M72 110.6L82.2104 119.331C83.2009 120.178 84.7237 119.867 85.3023 118.699L102 85",
    stroke: "#3AB83D",
    strokeWidth: 11,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M74 112.6L84.2104 121.331C85.2009 122.178 86.7237 121.867 87.3023 120.699L104 87",
    stroke: "#C4FAC5",
    strokeWidth: 11,
    strokeLinecap: "round"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_dd_4149_13)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 142.53,
    cy: 39.509,
    rx: 49.0846,
    ry: 21.509,
    fill: "#79D37B"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M128 31.6L138.21 40.3311C139.201 41.178 140.724 40.8667 141.302 39.699L158 6",
    stroke: "#3AB83D",
    strokeWidth: 11,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M130 33.6L140.21 42.3311C141.201 43.178 142.724 42.8667 143.302 41.699L160 8",
    stroke: "#C4FAC5",
    strokeWidth: 11,
    strokeLinecap: "round"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_dd_4149_13)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 77,
    cy: 198,
    rx: 10,
    ry: 4,
    fill: "#3E3E3E"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 77,
    cy: 198,
    rx: 3,
    ry: 1,
    fill: "black"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_dd_4149_13)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 76,
    cy: 194,
    rx: 10,
    ry: 4,
    fill: "#3E3E3E"
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 76,
    cy: 194,
    rx: 3,
    ry: 1,
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M73 192C72.6667 192 68 192.5 68 194.5",
    stroke: "#535353",
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36.0469,
    y: 190.196,
    width: 32.3912,
    height: 7.75988,
    transform: "rotate(-19.22 36.0469 190.196)",
    fill: "#565656"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40.4922,
    y: 190.012,
    width: 25.0988,
    height: 1.46533,
    rx: 0.732666,
    transform: "rotate(-19.22 40.4922 190.012)",
    fill: "#656565"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 64.1016,
    y: 174.506,
    width: 4.56438,
    height: 22,
    rx: 1,
    transform: "rotate(-19.22 64.1016 174.506)",
    fill: "#242424"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 69.3984,
    y: 175.836,
    width: 4.56438,
    height: 16,
    rx: 1,
    transform: "rotate(-19.22 69.3984 175.836)",
    fill: "#242424"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 43.8633,
    y: 204.299,
    width: 4.56438,
    height: 22,
    rx: 1,
    transform: "rotate(160.78 43.8633 204.299)",
    fill: "#242424"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 38.5664,
    y: 202.969,
    width: 4.56438,
    height: 16,
    rx: 1,
    transform: "rotate(160.78 38.5664 202.969)",
    fill: "#242424"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 66.1562,
    y: 174.849,
    width: 1.82575,
    height: 8,
    rx: 0.912877,
    transform: "rotate(-19.22 66.1562 174.849)",
    fill: "#535353"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 71.4531,
    y: 176.179,
    width: 1.82575,
    height: 7,
    rx: 0.912877,
    transform: "rotate(-19.22 71.4531 176.179)",
    fill: "#535353"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 31.0391,
    y: 189.706,
    width: 1.82575,
    height: 8,
    rx: 0.912877,
    transform: "rotate(-19.22 31.0391 189.706)",
    fill: "#535353"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 34.3594,
    y: 185.37,
    width: 1.82575,
    height: 7,
    rx: 0.912877,
    transform: "rotate(-19.22 34.3594 185.37)",
    fill: "#535353"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M188 135C194 135.5 194.5 138 195 142C195.5 138 197 135.5 202 135C197 134.5 195.5 132 195 128C194.5 132 194 134.5 188 135Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 33C6 33.5 6.5 36 7 40C7.5 36 9 33.5 14 33C9 32.5 7.5 30 7 26C6.5 30 6 32.5 0 33Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_4149_13",
    x: 10.7188,
    y: 179.042,
    width: 98.168,
    height: 49.6362,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.61815
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.811765 0 0 0 0 0.486275 0 0 0 0 0.109804 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4149_13"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.30908
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.810807 0 0 0 0 0.485582 0 0 0 0 0.111196 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_4149_13",
    result: "effect2_dropShadow_4149_13"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_4149_13",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_4149_13",
    x: 84.6211,
    y: 340.083,
    width: 98.168,
    height: 49.6362,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.61815
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0700219 0 0 0 0 0.398143 0 0 0 0 0.714404 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4149_13"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.30908
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.027451 0 0 0 0 0.168627 0 0 0 0 0.537255 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_4149_13",
    result: "effect2_dropShadow_4149_13"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_4149_13",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_4149_13",
    x: 68.0781,
    y: 420.604,
    width: 98.168,
    height: 49.6362,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.61815
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0700219 0 0 0 0 0.398143 0 0 0 0 0.714404 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4149_13"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.30908
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.027451 0 0 0 0 0.168627 0 0 0 0 0.537255 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_4149_13",
    result: "effect2_dropShadow_4149_13"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_4149_13",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_dd_4149_13",
    x: 38.2969,
    y: 259.562,
    width: 98.168,
    height: 49.6362,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.61815
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0700219 0 0 0 0 0.398143 0 0 0 0 0.714404 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4149_13"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.30908
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.4 0 0 0 0 0.713726 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_4149_13",
    result: "effect2_dropShadow_4149_13"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_4149_13",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_dd_4149_13",
    x: 38.2969,
    y: 98.5205,
    width: 98.168,
    height: 49.6362,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.61815
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.203922 0 0 0 0 0.682353 0 0 0 0 0.211765 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4149_13"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.30908
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.202349 0 0 0 0 0.684033 0 0 0 0 0.213053 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_4149_13",
    result: "effect2_dropShadow_4149_13"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_4149_13",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_dd_4149_13",
    x: 93.4453,
    y: 18,
    width: 98.168,
    height: 49.6362,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.61815
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.203922 0 0 0 0 0.682353 0 0 0 0 0.211765 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4149_13"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.30908
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.202349 0 0 0 0 0.684033 0 0 0 0 0.213053 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_4149_13",
    result: "effect2_dropShadow_4149_13"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_4149_13",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_dd_4149_13",
    x: 67,
    y: 194,
    width: 20,
    height: 11,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.152941 0 0 0 0 0.152941 0 0 0 0 0.152941 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4149_13"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.151383 0 0 0 0 0.151383 0 0 0 0 0.151383 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_4149_13",
    result: "effect2_dropShadow_4149_13"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_4149_13",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_dd_4149_13",
    x: 66,
    y: 190,
    width: 20,
    height: 11,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.152941 0 0 0 0 0.152941 0 0 0 0 0.152941 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4149_13"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.151383 0 0 0 0 0.151383 0 0 0 0 0.151383 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_4149_13",
    result: "effect2_dropShadow_4149_13"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_4149_13",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath);
export default __webpack_public_path__ + "static/media/path.2515d016b1725b349a836de96a4a2633.svg";
export { ForwardRef as ReactComponent };